import {
  Configure,
  HierarchicalMenu,
  RangeInput,
  RefinementList,
  SearchBox,
} from "react-instantsearch";
import { BaseFacet } from "../ca/filter/Facet";

export const KaFacet = () => (
  <BaseFacet className="fixed mt-14 p-2 sm:w-[20rem] lg:w-[23rem] flex z-10 overflow-y-scroll h-screen bg-white">
    <Configure filters="zone_1:Groningen OR zone_1:Drenthe" />
    <div className="border-1 border-gray p-2">
      <SearchBox placeholder="Zoek op adres / kadastraal nummer" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Provincie/gemeente</p>
      <HierarchicalMenu attributes={["zone_1", "zone_2"]} limit={50} sortBy={["name"]} />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Oppervlakte bebouwd</p>
      <RangeInput attribute="building_area" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Grondgebruik</p>
      <RefinementList attribute="land_cover" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Bebouwde kom</p>
      <RefinementList attribute="built_up_area" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Archeologische waarde</p>
      <RefinementList attribute="arch_monuments" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>NatuurNetwerkNederland</p>
      <RefinementList attribute="nnn" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Natura 2000</p>
      <RefinementList attribute="natura_2000" />
    </div>
  </BaseFacet>
);
